import { Client } from "@stomp/stompjs";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SockJS from "sockjs-client";
import { addNotification } from "../../redux/Actions/notificationActions";

const useWebSocketNotifications = () => {
  const dispatch = useDispatch();

  const studentId = useSelector((state) => state.auth.user.studentId);

  useEffect(() => {
    if (!studentId) {
      console.warn("⚠️ No student ID found in token.");
      return;
    }

    const wsUrl = `${process.env.REACT_APP_API_URL}/ws`;
    const socket = new SockJS(wsUrl);

    const stompClient = new Client({
      webSocketFactory: () => socket,
      reconnectDelay: 5000,
      onConnect: () => {
        console.log("✅ WebSocket Connected!");
        const topic = `/topic/notifications/${studentId}`;

        stompClient.subscribe(topic, (message) => {
          const notif = JSON.parse(message.body);
          dispatch(addNotification(notif));
        });
      },
      onStompError: (frame) => {
        console.error("❌ STOMP error", frame.headers["message"]);
      },
    });

    stompClient.activate();

    return () => {
      stompClient.deactivate();
    };
  }, [dispatch, studentId]);
};

export default useWebSocketNotifications;
